import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
// Components
import { Snackbar, UpdateUser } from "@/components/index";
// Entities
import { User, Company } from "@/entities/index";

@Component({
  components: {
    UpdateUser,
    Snackbar,
  },
})
export default class Users extends Vue {
  users: User[] = [];
  companies: Company[] = [];

  myUserId = 0;
  role = "";
  lang = "";
  selectedUser = {};

  updateUserForm = false;

  headersUsersTable = [
    {
      text: "Prénom",
      align: "start",
      value: "firstname",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Nom",
      value: "lastname",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Rôle",
      value: "role",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Langue",
      value: "lang",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Assigné à",
      value: "company.name",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Modifier",
      value: "updateUser",
      class: "indigo--text text--darken-4",
      sortable: false,
    },
  ];

  // ========== CRUD ========== //

  handleEditUser(item: User): void {
    this.myUserId = item.id;
    this.selectedUser = {
      role: item.role,
      lang: item.lang,
    };
    this.updateUserForm = true;
  }

  handleUpdateUser(updateUser: any): void {
    axios
      .put(`/api/users/${this.myUserId}`, {
        role: updateUser.role,
        lang: updateUser.lang,
      })
      .then(() => {
        this.updateUserForm = false;
        this.myUserId = 0;
        this.showSnackbarUpdateUser();
        this.allUsers();
      });
  }

  async allUsers(): Promise<void> {
    this.users = (await axios.get(`/api/users`)).data as User[];
  }

  async allCompanies(): Promise<void> {
    this.companies = (await axios.get(`/api/companies`)).data as Company[];
  }

  mounted(): void {
    this.allUsers();
    this.allCompanies();
  }

  // ========== OTHER METHODS ========== //

  clear(): void {
    const btnClear = document.getElementById("btnClear");
    btnClear?.classList.add("clicked");
    setTimeout(() => {
      btnClear?.classList.remove("clicked");
    }, 500);

    this.selectedUser = {
      role: "",
      lang: "",
    };
  }

  colorRow(item: User): any {
    const position = this.users.indexOf(item, 0);
    if (position % 2 == 0) {
      return "light-green lighten-5";
    }
  }

  showSnackbarUpdateUser(): void {
    const snackbarUpdateUser = this.$refs.snackbarUpdateUser as Snackbar;
    snackbarUpdateUser.show();
  }
}
